<template>
  <v-notification :link="toSettings" :title="$t('title')" :details="$t('body')" actions warning> </v-notification>
</template>

<script>
import { VNotification } from '@argon/app/components'

export default {
  name: 'InvitationNotification',
  components: {
    VNotification
  },
  methods: {
    toSettings() {
      this.$router.push({ name: 'me' })
    }
  }
}
</script>
<i18n>
{
  "en": {
    "body": "You have been invited to join one or more organization. Please check your profile page for more details.",
    "title": "You have pending invitations"
  },
  "fr": {
    "body": "Vous avez été invité(e) à rejoindre une ou plusieurs organisations. Veuillez consulter votre profile pour plus de détails.",
    "title": "Vous avez des invitations en attente"
  }
}
</i18n>
